import { SVGProps, Ref, forwardRef } from 'react';

export const StarCircleFilledSize16Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={16} height={16} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <g>
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M8 .5c5.625 0 7.5 3.75 7.5 7.5s-1.875 7.5-7.5 7.5S.5 11.75.5 8 2.375.5 8 .5m0 3.167c-.464 0-.737.686-1.284 2.059l-.122.305-.301.026c-1.418.12-2.127.18-2.27.64-.144.461.396.946 1.476 1.914l.218.196-.07.311c-.33 1.447-.494 2.17-.119 2.455.376.285.983-.103 2.197-.877l.266-.17.267.17c1.214.774 1.82 1.162 2.196.877.375-.285.211-1.008-.118-2.455l-.067-.298.232-.209c1.08-.968 1.62-1.453 1.476-1.914-.143-.46-.852-.52-2.269-.64l-.302-.026-.122-.305C8.737 4.353 8.464 3.667 8 3.667"
                    fill="currentColor"
                />
            </g>
        </g>
    </svg>
));
StarCircleFilledSize16Glyph.displayName = 'StarCircleFilledSize16Glyph';
